import { has } from "../../../../../utils/menu-context";
import { callHazObject } from "./fee-rate.section";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["excludeNetAmount"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (["02", "18", "19"].includes(modelRef?.refRequestDoc?.key)) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["excludeQty"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (["03", "08", "09", "10", "11"].includes(modelRef?.refRequestDoc?.key)) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["excludeOperations", "excludeHazSpecies"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (["04", "05"].includes(modelRef?.refRequestDoc?.key)) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["excludeProducts"].includes(field?.key);
            },
            inputPropField: ({ modelRef }) => {
                if (["03", "04", "05", "08", "09", "10", "11",].includes(modelRef?.refRequestDoc?.key)) {
                    return {
                        list: ({ searchQuery }) => callHazObject({ searchQuery }).then(items => items.map(item => ({ refHazObject: item }))),
                        optKey: "refHazObject.id",
                        renderLabel: ({ item }) => <span>{item.refHazObject?.nameTh} - {item.refHazObject?.refSpecies?.value}</span>,
                    }
                }
                return {}
            },
        },
        {
            check: ({ field }) => {
                return ["excludeToUses"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (["03", "04", "05"].includes(modelRef?.refRequestDoc?.key)) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["excludeHazLicenseObjectives"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (["11"].includes(modelRef?.refRequestDoc?.key)) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["excludeTransportObjectives"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (["18", "19"].includes(modelRef?.refRequestDoc?.key)) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["excludeSourceCountries"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (["02", "18", "19"].includes(modelRef?.refRequestDoc?.key)) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["excludeDestinationCountries"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (["09", "18", "19"].includes(modelRef?.refRequestDoc?.key)) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["excludeManufactureCountries"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (["04", "05", "08", "10"].includes(modelRef?.refRequestDoc?.key)) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["excludeCarrySourceCountries"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                if (["02", "18", "19"].includes(modelRef?.refRequestDoc?.key)) {
                    return true
                }
                return false;
            },
        },
    ];
};
